module.exports = __webpack_public_path__ + "media/img/seed/2-841a68355642d511c83002eb2b46b13c.jpeg";